import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import i18n from "./i18n";
import { queryClient, restoreQueryCache } from "./queryClient";
import { routerDefaults } from "./routerOptions";
import { routeTree } from "./routeTree.gen";
import "./index.css";

await restoreQueryCache();

const router = createRouter({
  routeTree,
  context: { queryClient },
  ...routerDefaults,
});

// head() reads i18n outside React, so re-run it when the language changes.
i18n.on("languageChanged", () => router.invalidate());

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById("root");
if (!root) {
  throw new Error("missing #root element");
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>
);
